import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AttributeDefinition } from '../../models/attribute-definition';
import { AttributeComponent } from '../../interfaces/attribute.component';
import { FormControl, FormGroup } from '@angular/forms';
import { AttributeControlService } from '../../attribute-control-service';
import { LookupListItem } from '../../models/lookup-list-item';
import { LookupService } from 'src/app/services/lookup.service';
import { ActivatedRoute } from '@angular/router';
import { TokenHelper } from 'src/app/services/helpers/token.helper';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit, AttributeComponent {
  @Input() formGroup: FormGroup;
  @Input() attributeDefinition: AttributeDefinition;

  @Output() onRemove = new EventEmitter<number>();
  options: LookupListItem[] = [];

  constructor(
    private lookup: LookupService,
    public _attributeControlService: AttributeControlService<number[]>,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const v = this.attributeDefinition.value;
    const initialIds: number[] = Array.isArray(v)
      ? v.map(x => Number(x)).filter(Number.isFinite)
      : (v != null && Number.isFinite(Number(v)) ? [Number(v)] : []);

    this._attributeControlService.addFormControl(
      this.attributeDefinition.formControlName,
      this.attributeDefinition.isRequired,
      initialIds,
      this.formGroup
    );

    const listId = this.attributeDefinition.attributeLookupListId;
    if (listId) {
      const token = TokenHelper.getToken(this.activatedRoute);
      this.lookup.getResourceAttributeLookupValues(token, listId).subscribe({
        next: rows => (this.options = rows.map(LookupListItem.fromDto)),
        error: () => (this.options = [])
      });
    }
  }

  getErrorMessage(): string {
    if (!this.control) return '';
    if (this.control.hasError('required')) return `${this.label} is required.`;
    return '';
  }

  get control(): FormControl {
    return this.formGroup.get(this.attributeDefinition.formControlName) as FormControl;
  }

  get label(): string {
    return (this.attributeDefinition?.name || '').replace(/\s*[:*]+$/, '').trim();
  }

  value(): number[] {
    const ids = (this.control?.value as number[]) || [];
    this.attributeDefinition.value = ids;
    return ids;
  }

  clear(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.control.setValue([], { emitEvent: true });
    this.control.markAsDirty();
    this.control.markAsTouched();
    this.attributeDefinition.value = [];
  }

  ngOnDestroy(): void {
    this._attributeControlService.removeControl(this.attributeDefinition.formControlName, this.formGroup);
  }
}
